import {Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Observable, of, Subscription} from 'rxjs';
import {ANIMATION_BUTTON} from "../../../../constants/fields.constants";
import {ActionButton} from "../../../../../common/interfaces/data.interfaces";
import {BaseComponent} from "../../../data-table-hybrid/utility/base-component";


@Component({
  selector: 'action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ActionButtonsComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() actionButtons: ActionButton[] = [];
  @Input() animation = ANIMATION_BUTTON;
  @Input() data = undefined;
  @Input() onMenu = false;
  @Input() index = 0;
  @Input() loadingBtnAction: { [itemId: string]: boolean } = {};

  @Input() model = undefined;
  @Input() upDateButton$: Observable<ActionButton> = of({});

  @Input() buttonHolderClass = 'm-1 inline-flex items-center';

  fabClass = 'bg-gradient-primary';
  protected readonly undefined = undefined;

  ngOnInit() {
    this.subscriptions.add(
        this.upDateButton$?.subscribe(bInfo => {
          const fields = ['label', 'slug', 'icon', 'callback'];
          let btn = this.actionButtons?.find(b =>
              this.dataService.hasCommonFieldValue(b, bInfo, fields)
          );
          if (btn) btn = {...btn, ...bInfo};
        })
    );
  }

  async action(btn: ActionButton) {
    if (btn.disabled) return;
    const msg = btn.confirmMessage ?? 'Confirm';
    if (btn.confirmFirst && (await this.notificationService.confirmation({message:msg})).dismiss) return;
    btn.callBack(btn.data ?? this.data);
  }

  override ngOnDestroy() {
    this.subscriptions.unsubscribe();
    super.ngOnDestroy();
  }
}
